import { Column, cssVar, Grid, Label, Row, useAlignments } from 'metrix-common3';
import styled from 'styled-components';

// One wide table at every breakpoint - the FilterableList track scrolls horizontally on screens too
// narrow to fit it. Column spans (matching the header in ../../fields.js) are set on xs only.

// Long values truncate on one line with an ellipsis (full value on hover); names wrap.
const EllipsisLabel = styled(Label)`
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const WrapLabel = styled(Label)`
    display: block;
    overflow-wrap: break-word;
`;

const Cell = ({ text, textAlign, wrap }) => {
    if (wrap) return <WrapLabel text={text} textAlign={textAlign} />;
    return <EllipsisLabel text={text} title={text ? String(text) : undefined} textAlign={textAlign} />;
};

// Render the reference through the same EllipsisLabel (so it shares the <p> margin/baseline of the
// other cells), coloured like a link and wrapped in an anchor.
const RefLink = styled.a`
    display: block;
    text-decoration: none;
    cursor: pointer;
`;

const PolicyListItem = ({ policy, context }) => {
    const alignments = useAlignments();

    const {
        submissionReferenceNumber,
        policyNumber,
        insuredName,
        productDescription,
        createdOnDate,
        assignedTo,
        transactionType,
        policyTransactionGuid,
    } = policy;

    const profileLink = `${context.configuration.policyWeb}/profile?entity=${policyTransactionGuid}`;

    return (
        <Grid>
            <Row>
                <Column xs={1.5}>
                    <RefLink href={profileLink}>
                        <EllipsisLabel
                            text={submissionReferenceNumber}
                            color={cssVar.colorSecondary}
                            clickable
                            title={submissionReferenceNumber}
                            textAlign={alignments.left}
                        />
                    </RefLink>
                </Column>
                <Column xs={1.5}>
                    <Cell text={policyNumber} textAlign={alignments.left} />
                </Column>
                <Column xs={3}>
                    <Cell text={insuredName} wrap textAlign={alignments.left} />
                </Column>
                <Column xs={1.5}>
                    <Cell text={productDescription} textAlign={alignments.left} />
                </Column>
                <Column xs={1.5}>
                    <Cell text={createdOnDate} textAlign={alignments.left} />
                </Column>
                <Column xs={2}>
                    <Cell text={assignedTo || ''} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={transactionType} textAlign={alignments.left} />
                </Column>
            </Row>
        </Grid>
    );
};

export default PolicyListItem;
